import * as Sentry from '@sentry/angular';

import { environment } from '@env/environment';

export class BugTracker {
  static init(){
    if (environment.sentryEnabled && environment.sentry) {
      Sentry.init({
        dsn: environment.sentry.dsn,
        environment: environment.envName,
        sendDefaultPii: true,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration(),
          // Sentry.browserProfilingIntegration()
        ],
        tracesSampleRate: environment.sentry.tracesSampleRate,
        replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
        replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate,
        profilesSampleRate: environment.sentry.profilesSampleRate,
        _experiments: { enableLogs: true },
        // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      });
    }
  }
}
